import { render, staticRenderFns } from "./BalanceMoneyFlow.vue?vue&type=template&id=a2b81484&scoped=true"
import script from "./BalanceMoneyFlow.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b81484",
  null
  
)

export default component.exports